import React, { memo as Memo, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

//* Components
import Icon from 'components/common/Icon';
import Text from 'components/common/Text';

//* Style
import ShareStyle from './style';

const ShareLink = Memo((props) => {
	//! State
	const [isCopied, setIsCopied] = useState(false);

	//! Copy url function
	const copyUrl = () => {
		const el = document.createElement('input');
		el.value = window.location.href;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	const handleCopyLinkClick = () => {
		copyUrl();
		setIsCopied(true);

		setTimeout(() => {
			setIsCopied(false);
		}, 5000);
	};

	const router = useRouter();
	const url = useMemo(() => process.env.host + router.asPath, [router]);
	const facebookUrl = useMemo(() => `https://www.facebook.com/sharer/sharer.php?u=${url}`, [url]);
	const twitterUrl = useMemo(() => `https://twitter.com/intent/tweet?url=${url}`, [url]);

	return (
		<ShareStyle className={props.className || ''}>
			<div className='link-wrap'>
				<a
					target='_blank'
					rel='noopener noreferrer'
					aria-label='facebook'
					className='share-link'
					href={facebookUrl}
				>
					<Icon name='facebook-share' />
				</a>

				<Text
					className={'p link-text font-ping-medium text-center'}
					text={'Facebook'}
				/>
			</div>

			<div className='link-wrap'>
				<a
					target='_blank'
					rel='noopener noreferrer'
					aria-label='twitter'
					className='share-link'
					href={twitterUrl}
				>
					<Icon name='twitter' />
				</a>

				<Text
					className={'p link-text font-ping-medium text-center'}
					text={'Twitter'}
				/>
			</div>

			<div className={`link-wrap ${isCopied ? 'disable' : ''}`}>
				<a
					rel='noopener noreferrer'
					aria-label='link'
					className='share-link'
					onClick={handleCopyLinkClick}
				>
					<Icon name='link' />
				</a>

				<Text
					className={`p link-text font-ping-medium text-center`}
					text={isCopied ? 'copied' : 'copyLink'}
				/>
			</div>
		</ShareStyle>
	);
});

export default ShareLink;
